<div class="folders-wrapper" [id]="foldersTableID" [class.selection-active]="hasActiveSelection">
  <div class="folders-header">
    <app-folder-header
      [title]="foldersConfig.config.title | translate"
      [mainUrl]="foldersConfig.config.link"
      [allowCopy]="foldersConfig.config.allowCopy"
      [filter]="foldersConfig?.filter"
    ></app-folder-header>

    <div class="custom-inputs">
      <input
        [(ngModel)]="searchWord"
        (ngModelChange)="customSearch()"
        name="searchWord"
        class="search-input"
        aria-controls="open"
        autocomplete="off"
        [class.active]="searchWord"
        type="search"
        placeholder="{{'SHARED.Quick_Search' | translate}}"
      >
      <ion-icon (click)="clearSearch()" *ngIf="searchWord" class="custom-close-icon" name="close"></ion-icon>
    </div>
    <app-folder-search
      [dataTableOptions]="searchModalTableOptions"
      [foldersList]="allFoldersList"
      [folderUrl]="foldersConfig.config.link"
      [panelConfig]="panelConfig"
      [setSelection]="updateSearchSelection"
      [tabTitle]="foldersConfig.tabTitle"
    ></app-folder-search>
  </div>

  <div class="folders-button-group">
    <button *ngIf="!foldersConfig.config?.noAddFolder"
      class="button-styled"
      (click)="onClickAddFolder()"
    >
      {{ foldersConfig.config.addFolderBtnText | translate }}
    </button>
    <button *ngIf="currentFolderId || !foldersConfig.config?.noItemsAtRoot"
      class="button-styled"
      (click)="onClickAddItem()"
    >
      {{ foldersConfig.config.addItemBtnText | translate }}
    </button>
    <button *ngIf="showBulkImport"
      class="button-styled"
      (click)="onClickBulkImport()"
    >
      {{ foldersConfig.config.bulkImport?.btnText | translate }}
    </button>

    <button class="button-styled"
            *ngIf="mainDataTableOptions?.data?.length && dataTableComponent?.tableId"
            (click)="editColumns()">
      {{ 'MGMT_LIST.Select_Columns' | translate }}
    </button>
  </div>

  <app-folder-item
    *ngFor="let folderItem of filteredFoldersList"
    [folderItem]="folderItem"
    [mainUrl]="foldersConfig.config.link"
    [searchWord]="searchWord"
    [customIcon]="foldersConfig?.icon"
    (folderSelect)="onFolderSelect()"
  ></app-folder-item>

  <app-data-table
    *ngIf="tableDataReady && (currentFolderId || !foldersConfig.config?.noItemsAtRoot)"
    [hidden]="!mainDataTableOptions?.data?.length"
    [dataTableOptions]="mainDataTableOptions"
    [tableId]="foldersTableID + '_' + currentFolderId"
    (rendered)="onMainTableRendered()"
    class="data-table"
  ></app-data-table>

  <div class="empty-message" *ngIf="!mainDataTableOptions?.data?.length && !filteredFoldersList?.length">{{ emptyMessage | translate }}</div>
</div>

<ion-footer *ngIf="hasActiveSelection" class="folder-footer" no-border>
  <app-removal-panel
    [subTitle]="panelConfig.subTitle"
    [title]="panelConfig.title"
  >
    <ion-button
      *ngFor="let btn of panelConfig?.buttons"
      class="page-button"
      color="secondary"
      (click)="btn.action()"
    >
      {{btn.buttonText | translate}}
    </ion-button>
  </app-removal-panel>
</ion-footer>
